import { assertNever } from '@cronos-app/utils';
import { ChainId, ChainLayer, isChainIdCronosEvm, isChainIdL1, isChainIdL2, } from '../types';
export const getLayerOfChain = (chainId) => {
    if (isChainIdL1(chainId)) {
        return ChainLayer.L1;
    }
    if (isChainIdL2(chainId)) {
        return ChainLayer.L2;
    }
    if (isChainIdCronosEvm(chainId)) {
        return ChainLayer.CronosEvm;
    }
    assertNever(chainId);
};
export const getChainOfLayer = (desiredNetwork, layer) => {
    switch (layer) {
        case ChainLayer.L1:
            return desiredNetwork;
        case ChainLayer.L2:
            return getRelatedL2Chain(desiredNetwork);
        case ChainLayer.CronosEvm:
            return getRelatedCronosEvmChain(desiredNetwork);
    }
};
/**
 * multi l1 to one l2, for example, ethereum and zksync era to zkEVM
 * @param chainId
 * @returns
 */
export const getRelatedL2Chain = (chainId) => chainId === ChainId.ETHEREUM || chainId === ChainId.CRONOS_EVM_MAINNET
    ? ChainId.ZK_EVM
    : ChainId.ZK_EVM_TEST;
export const getRelatedCronosEvmChain = (chainId) => chainId === ChainId.ETHEREUM
    ? ChainId.CRONOS_EVM_MAINNET
    : ChainId.CRONOS_EVM_TESTNET;
